<script lang="ts">
  import Icons from "../icons/Icons.svelte";
</script>

<div class="hidden">
  <Icons />
</div>
<slot />
